/**
 * Both sponsor data endpoints take the header filters as flat query params -
 * organization_id, cohort_id and year - so only the ones actually holding a
 * value are sent. Years come from a multi select, hence the comma separated
 * list.
 */
export const buildSponsorParams = ({
  organization_id,
  cohort_id,
  year,
} = {}) => {
  const params = {};

  if (organization_id) {
    params.organization_id = organization_id;
  }
  if (cohort_id) {
    params.cohort_id = cohort_id;
  }
  if (Array.isArray(year)) {
    if (year.length > 0) {
      params.year = year.join(",");
    }
  } else if (year) {
    params.year = year;
  }

  return params;
};

export default buildSponsorParams;
